import { Text, tokens } from '@fluentui/react-components';
import type { IField } from '@moko/utils';
import { FieldWrapper } from './FieldWrapper';
import { useFieldReadOnly } from './fieldReadOnly';

interface TextFieldProps {
  field: IField;
  fieldValue: any;
}

export const TextField = ({ field, fieldValue }: TextFieldProps) => {
  const isReadOnly = useFieldReadOnly(field);
  const value =
    fieldValue == null || String(fieldValue).trim() === ''
      ? null
      : String(fieldValue);

  return (
    <FieldWrapper field={field}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          minHeight: '32px',
          paddingInlineStart: isReadOnly
            ? tokens.spacingHorizontalM
            : undefined,
        }}
      >
        {value !== null ? (
          <Text>{value}</Text>
        ) : (
          <Text italic>{field.placeholder ?? ''}</Text>
        )}
      </div>
    </FieldWrapper>
  );
};
